export default __webpack_public_path__ + "static/media/20.e4b12d40.jpg";